export default __webpack_public_path__ + "3022bcd348076768c8a5ab4824a3796e.svg";